export default __webpack_public_path__ + "d2b9d0715ac58ce937d3204fe417e105.png";